













































import {Component,Vue} from "vue-property-decorator";
import {mapGetters} from "vuex";
import User from "@/consoleapi/api/user";
import Sidebar from "@/components/Sidebar.vue";
import RestcommProfiles from "@/consoleapi/api/restcomm/profiles";

@Component({
  components:{
    Sidebar,
  },
  computed:
    mapGetters({
      pageTitle: 'title/pageTitle',
      tabName: 'tab/tabName'
    }),
})
export default class App extends Vue {
  public registered = true;
  public userName = 'ゲスト';

  private email = null;

  private sid = null;

  public mainPage = 'https://' + process.env.VUE_APP_HOST_NAME;

  public logoUrl = process.env.VUE_APP_HEADER_LOGO_FILE_URL;

  public bearerToken = this.$cookies.get(String(process.env.VUE_APP_COOKIE_BEARER_TOKEN));
  public refreshToken = this.$cookies.get(String(process.env.VUE_APP_COOKIE_REFRESH_TOKEN));
  public accountId = this.$cookies.get(String(process.env.VUE_APP_COOKIE_ACCOUNT_ID));
  public userId = this.$cookies.get(String(process.env.VUE_APP_COOKIE_COGNITO_USER_NAME));

  getProfile(){
    const profile = new RestcommProfiles();
    profile.setBearerToken(this.bearerToken);
    profile.find(this.accountId).then(response => {
      console.log(response.data);
      const account = response.data;
      this.email = account.email_address;
      this.sid = account.sid;
    }).catch(error => {
      console.log(error.response);
    });
  }

  mounted() {
    const user = new User();
    user.setBearerToken(this.bearerToken);
    user.show(this.accountId, this.userId)
            .then(response => {
              console.log('app');
              console.log(response.data);
              this.userName = response.data.user.name;
      });

    this.getProfile();
  }
}
